// extracted by mini-css-extract-plugin
export default {"container":"Container_container__ITA5v","dark":"Container_dark__Qqrls","mensagemAviso":"Container_mensagemAviso__U7AKW","darkMensagemAviso":"Container_darkMensagemAviso__q3AE9"};